import { fontVariants } from "theme/fontVariants"
import { fontSizes } from "theme/themeConfig"
import { colours } from "@shared/ui.design-system"

const quote = {
  position: "relative",
  paddingTop: 1,
  "&:first-of-type": {
    paddingTop: 3,
    "&::before": {
      fontSize: fontSizes["5"],
      content: "'“'",
      position: "absolute",
      top: 0,
      left: 0,
    },
  },
  "&:focus": {
    boxShadow: "0",
    background: `${colours.secondary.warm}`,
  },
}

export const Heading = {
  variants: {
    ...fontVariants,
    quote2: {
      ...fontVariants.demi2,
      ...quote,
    },
    quote3: {
      ...fontVariants.demi3,
      ...quote,
    },
  },
}
